import React, {useCallback} from 'react';
import {SubFormsList} from '../../types';
import {showHelp} from '../../common/helpPopover';
import {ResponsiveTabs} from '../Tabs/Tabs';
import {SidePanelSubforms} from '../../consts/EntityTypes';

type Props = {
    data: SubFormsList;
    componentClasses?: string;
    openSubForm: (subFormName: string, parentLevel: number, isHTMLForm?: boolean) => void;
    activeFormId?: string;
    level: number;
};

type TabDataType = {
    title: string;
    id: string;
    isHTMLForm: boolean;
    index: number;
};

export const SubFormList = ({
    data = [],
    componentClasses,
    openSubForm,
    activeFormId,
    level
}: Props) => {
    const mappedSubForms: TabDataType[] = data
        .map(
            (subform, index) =>
                (level !== 0 || !SidePanelSubforms.includes(subform.Type)) && {
                    title: subform.Title,
                    id: subform.Ename,
                    isHTMLForm: subform.IsText,
                    index
                }
        )
        .filter(Boolean);

    const onContextMenu = useCallback(async e => {
        const anchor = e.currentTarget;
        await showHelp({anchor, Fname: anchor.dataset.id});
    }, []);

    return (
        <div className={componentClasses}>
            <ResponsiveTabs
                data={mappedSubForms}
                onChange={(id, tabData) =>
                    openSubForm(id, level, (tabData as TabDataType).isHTMLForm)
                }
                activeId={activeFormId}
                onContextMenu={onContextMenu}
            />
        </div>
    );
};
